var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResourceActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4969 11.3829V3.33809C14.4969 2.53827 13.8437 1.94507 13.0506 2.01172H13.0106C11.6109 2.1317 9.48471 2.84487 8.29832 3.59136L8.18501 3.66468C7.99172 3.78465 7.6718 3.78465 7.47851 3.66468L7.31188 3.5647C6.12549 2.82487 4.00597 2.11837 2.60629 2.00506C1.81314 1.93841 1.16663 2.53827 1.16663 3.33142V11.3829C1.16663 12.0228 1.68651 12.6226 2.32636 12.7026L2.51965 12.7293C3.96598 12.9225 6.1988 13.6557 7.47851 14.3556L7.50517 14.3689C7.68513 14.4689 7.97173 14.4689 8.14502 14.3689C9.42473 13.6624 11.6642 12.9225 13.1172 12.7293L13.3372 12.7026C13.977 12.6226 14.4969 12.0228 14.4969 11.3829Z",
    stroke: "#EFFEF5",
    strokeWidth: 1.33303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.20264V14.9526",
    stroke: "#EFFEF5",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52087 6.95264H3.20837",
    stroke: "#EFFEF5",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95837 8.70264H3.20837",
    stroke: "#EFFEF5",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceActive);
export default __webpack_public_path__ + "static/media/resource-active.bf604791a3465374b50a697e5a3f28de.svg";
export { ForwardRef as ReactComponent };